const breadcrumbKeys = {
  all: ['breadcrumbs'],
  byParentId: (id?: string) => [...breadcrumbKeys.all, id],
  sharedByParentId: (id?: string) => ['shared', ...breadcrumbKeys.byParentId(id)]
};

export default breadcrumbKeys;
